import * as React from 'react';
import React__default from 'react';

function createCommonjsModule(fn) {
  var module = { exports: {} };
	return fn(module, module.exports), module.exports;
}

var _extends_1 = createCommonjsModule(function (module) {
function _extends() {
  module.exports = _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

module.exports = _extends;
});

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var objectWithoutPropertiesLoose = _objectWithoutPropertiesLoose;

var _excluded = ["color", "size", "style"];
var Icon = (function (SvgComponent) {
  return /*#__PURE__*/React__default.forwardRef(function (props, ref) {
    var _props$color = props.color,
        color = _props$color === void 0 ? 'currentColor' : _props$color,
        _props$size = props.size,
        size = _props$size === void 0 ? '1em' : _props$size,
        _props$style = props.style,
        style = _props$style === void 0 ? {} : _props$style,
        otherProps = objectWithoutPropertiesLoose(props, _excluded);

    return /*#__PURE__*/React__default.createElement(SvgComponent, _extends_1({
      ref: ref,
      fill: color,
      width: size,
      height: size,
      style: _extends_1({}, style)
    }, otherProps));
  });
});

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M637.739 390.656c-.299 0 5.205-3.499 16.554-10.539 12.715-7.68 24.576-13.61 35.627-17.792 7.168-2.688 17.365-5.248 30.592-7.765l5.248-24.32-31.573 7.253c-4.352.854-9.131 1.28-14.294 1.28-16.725 0-26.922-2.858-30.592-8.533a3.584 3.584 0 01-.512-2.005c0-3.2 2.134-7.126 6.528-11.776 4.352-4.694 8.064-7.211 11.136-7.552 3.115-.342 6.486-.512 10.155-.512 14.379 0 22.912 1.194 25.6 3.541l11.008-23.339c-.64 0-4.821-.981-12.501-2.986a53.504 53.504 0 00-14.294-2.262c-13.397 0-26.88 7.638-40.405 22.912-13.525 15.318-19.541 29.227-18.048 41.771.341 2.133 4.352 4.608 12.032 7.253 6.528 2.347 10.71 3.542 12.544 3.542-1.152.853-4.267 4.736-9.259 11.776-5.845 8.533-8.789 14.378-8.789 17.536 0 2.005 1.067 2.858 3.243 2.56zm35.413 296.917l52.608-44.885v-270.08l-52.65 39.381v275.584zm-182.101-26.88c22.613 0 33.877-11.349 33.877-34.09a33.707 33.707 0 00-9.045-23.894 30.464 30.464 0 00-23.296-9.685c-23.595 0-35.414 11.435-35.414 34.347 0 10.026 3.158 18.09 9.43 24.192a33.579 33.579 0 0024.448 9.173zm-210.134 23.851a294.827 294.827 0 0064.214-8.021c14.208-3.2 28.501-6.4 42.88-9.814 14.378-3.328 23.68-5.632 27.946-6.997 4.267-1.323 6.827-5.461 7.68-12.373.811-6.955 1.238-12.459 1.238-16.47 0-56.49-6.827-104.789-20.566-144.938-11.52-33.92-24.576-59.008-39.125-75.222l-34.347 64.214c12.374 13.013 23.552 31.488 33.579 55.424 11.392 31.914 17.067 52.053 17.067 60.416 0 2.858-12.8 6.826-38.4 12.032-12.8 2.986-23.296 4.821-31.318 5.376-8.021.597-15.445.896-22.314.896a90.88 90.88 0 01-35.584-7.51c-8.704-4.352-13.312-15.488-13.824-33.365l-1.707-18.56a2.219 2.219 0 00-1.024-.256c-1.835 0-3.584 2.304-5.29 6.912-1.665 4.608-3.67 13.696-5.974 27.307-2.39 13.653-3.627 23.594-3.797 29.866-.171 6.272-.256 10.838-.256 13.654-.342 22.741 4.096 36.864 13.312 42.368 10.538 9.557 25.728 14.549 45.653 15.061zM635.82 15.36c274.261 68.437 441.258 346.197 372.821 620.544-68.352 274.261-346.197 441.173-620.544 372.736C113.749 940.203-53.077 662.443 15.36 388.181 83.797 113.877 361.515-53.12 635.819 15.36zm-10.326 41.387c-251.392-62.72-506.026 90.282-568.746 341.76C-5.973 649.94 146.944 904.49 398.42 967.253c251.478 62.72 506.155-90.282 568.832-341.674 62.72-251.435-90.325-506.112-341.76-568.832z"
});

function SvgAed(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "AED_svg__icon",
    width: 200,
    height: 200,
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _ref);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAed);

var ForwardIcon = /*#__PURE__*/React__default.forwardRef(function (props, ref) {
  return /*#__PURE__*/React__default.createElement(ForwardRef, _extends_1({}, props, {
    ref: ref
  }));
});
var KuFoxIcons = Icon(ForwardIcon);
KuFoxIcons.displayName = 'AEDOutlined';

export default KuFoxIcons;
